/** Notice about legal-entity data shown in market cabinet (old consent URL). */
export const PERSONAL_DATA_CONSENT_DOCUMENT_VERSION = '2026-08-15'

export const PERSONAL_DATA_CONSENT_PATH = '/legal/personal-data-consent'

export const PERSONAL_DATA_CONSENT_OPERATOR = {
  legalName: 'Индивидуальный предприниматель Новоселов Федор Владимирович',
  shortName: 'ИП Новоселов Ф.В.',
  inn: '110119365449',
  ogrnip: '318112100016230',
  address: '614095, г. Пермь, ул. Карпинского, д. 65, кв. 228',
  privacyEmail: 'support@provisium.ru',
  sites: 'provisium.ru и market.provisium.ru',
} as const
